import { agendaItemsExportService } from "@/services/agendaItemsExportService";
import type { AgendaItem } from "@repo/types";
import { ExportForm } from "../common/ExportForm";

export interface ExportAgendaItemFormProps {
  getAgendaItems: () => AgendaItem[];
  getPreselectedFields: () => string[];
  onCancel?: () => void;
}

export const ExportAgendaItemForm = ({
  getAgendaItems,
  getPreselectedFields,
  onCancel,
}: ExportAgendaItemFormProps) => {
  return (
    <ExportForm<AgendaItem>
      getData={getAgendaItems}
      getPreselectedFields={getPreselectedFields}
      onCancel={onCancel}
      downloadName="agenda-items.csv"
      exportService={agendaItemsExportService}
    />
  );
};
